import { Component, Optional, Inject, OnDestroy } from '@angular/core';
import { ApiService } from 'app/api.service';
import { FinancialYearService } from 'app/financial-year.service';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ImportStatementViewComponent } from 'app/import-statement-view/import-statement-view.component';
import { LedgerBookComponent } from 'app/ledger-book/ledger-book.component';
import { VoucherBreakdownDialogComponent } from 'app/voucher-breakdown-dialog/voucher-breakdown-dialog.component';

@Component({
  selector: 'app-statement-view',
  templateUrl: './statement-view.component.html',
  styleUrls: ['./statement-view.component.scss']
})
export class StatementViewComponent {
  profitCost_data: any[] = [];
  profitcost: any;
  profit_cost_id: any;
  section_data: any[] = [];
  section: any;
  section_id: any;
  store: any;
  store_id: any;
  statementTransactions: any[] = [];
  openedGroups: any[] = [];
  data: any;
  statementType: any;
  statement: any;
  isExpanded: boolean = false;
  creditSide: any;
  debitSide: any;
  Debit:any;
  branch:any;
  branches:any;
  fromDate: string = '';
  toDate: string = '';
  minDate: string = '';
  maxDate: string = '';
  subscription: any;
  selectedFinancialYears: string[] = [];
  isModal: boolean = false;
  statement_name:any;
  ledgerType: any; //model
  ledgerTypeList: any[] = []; //loop
  value: any; //model
  balance = [
    { id: 1, name: 'With Value' },
    { id: 2, name: 'Without Value' }
  ];
  store_data: any[] = [];
  profit_cost: any;
  employee_data: any[] = [];
  selectedEmployee: any[] = [];
  constructor(
    private apiService: ApiService,
    private dialog: MatDialog,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any,
    @Optional() public dialogRef: MatDialogRef<StatementViewComponent>,
    private financialYearService: FinancialYearService
  ) {
    if (this.dialogData && this.dialogData.is_modal) {
      this.isModal = true;
      if (this.dialogData.statementType) {
        this.statementType = this.dialogData.statementType;
      }
    }
  }
  ngOnInit() {
    this.subscription = this.financialYearService.selectedYears$.subscribe(years => {
      this.selectedFinancialYears = years;
      this.setDatesFromFinancialYears(years);
      this.onSearch();
    });
    this.fetchStatement();
    this.fetchBranches();
    this.fetchLedgerTypeData();
    this.getEmployeeData();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  setDatesFromFinancialYears(years: string[]) {
    let minYear = Infinity;
    let maxYear = -Infinity;

    years.forEach(yearRange => {
      const parts = yearRange.split('-');
      const start = parseInt(parts[0]);
      const end = parseInt(parts[1]);
      if (start < minYear) minYear = start;
      if (end > maxYear) maxYear = end;
    });

    if (minYear !== Infinity && maxYear !== -Infinity) {
      this.minDate = `${minYear}-04-01`;
      this.maxDate = `${maxYear}-03-31`;

      this.fromDate = this.minDate;
      this.toDate = this.maxDate;
    }
  }

  closeModal() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
  fetchBranches() {
    this.apiService.getDatabranch().subscribe(response => {
      this.branches = response;
      console.log(this.branches,"branches");
    });
  }
  
  onBranchChange(event: any) {
    const branch = event.value;
    if (branch) {
      this.fetchProfitCost(branch.id);
    } else {
      this.profitCost_data = [];
    }
    this.profitcost = null;
    this.section_data = [];
    this.store_data = [];
    this.section = null;
    this.store = null;
  }

  fetchProfitCost(branch_id: any) {
    const postData = {
      branch_id: branch_id
    };
    this.apiService.getProfitCostByBranch(postData).subscribe(
      (response) => {
        this.profitCost_data = response;
        console.log('profit center', this.profitCost_data);
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }


  onProfitCostChange(profitCostId: any) {
    if (!profitCostId) {
      this.section_data = [];
      this.store_data = [];
      return;
    }
    this.profit_cost_id = profitCostId;
    this.fetchSection(profitCostId);
    this.fetchStoreData(profitCostId);
  }

  fetchSection(profit_id: any) {
    this.apiService.getSectionByProfitCost(profit_id).subscribe(
      (response) => {
        this.section_data = response;
        console.log('Section data loaded:', this.section_data);
      },
      (error) => {
        console.error('Error fetching sections with GET, trying POST:', error);
      }
    );
  }

  fetchStoreData(profitCostId: number) {
    const postData = { profit_cost_id: profitCostId };
    this.apiService.getStoreByPcCc(postData).subscribe(
      (response) => {
        this.store_data = response;
      },
      (error) => console.error(error)
    );
  }

  calculateOpeningBalanceAndSide(transactions: any[]): { balance: number, side: string } {
    let totalCrOpeningBalance = 0;
    let totalDrOpeningBalance = 0;

    transactions.forEach(transaction => {
      if (transaction.totalsubOpeningBalanceSide === 'Cr') {
        totalCrOpeningBalance += transaction.totalsubOpeningBalance;
      } else if (transaction.totalsubOpeningBalanceSide === 'Dr') {
        totalDrOpeningBalance += transaction.totalsubOpeningBalance;
      }
    });

    const balance = totalCrOpeningBalance - totalDrOpeningBalance;
    const side = totalCrOpeningBalance > totalDrOpeningBalance ? 'Cr' : 'Dr';

    return { balance: Math.abs(balance), side };

  }
  calculateClosingBalanceAndSide(transactions: any[]): { balance: number, side: string } {
    const openingBalanceAndSide = this.calculateOpeningBalanceAndSide(transactions);
    const debitAmount = this.calculateDebitAmount(transactions);
    const creditAmount = this.calculateCreditAmount(transactions);

    let closingBalance: number = 0;
    let closingBalanceSide: string = '';

    if (openingBalanceAndSide.side === 'Cr') {
      closingBalance = openingBalanceAndSide.balance + creditAmount - debitAmount;
      closingBalanceSide = closingBalance >= 0 ? 'Cr' : 'Dr';
    } else if (openingBalanceAndSide.side === 'Dr') {
      closingBalance = openingBalanceAndSide.balance + debitAmount - creditAmount;
      closingBalanceSide = closingBalance >= 0 ? 'Dr' : 'Cr';
    }
    return { balance: Math.abs(closingBalance), side: closingBalanceSide };
  }
  calculateDebitAmount(transactions: any[]): number {
    let totalDebitAmount = 0;
    transactions.forEach(transaction => {
      totalDebitAmount += transaction.totalsubDebitAmount;
    });
    this.Debit=totalDebitAmount;
    return totalDebitAmount;
  }
  calculateCreditAmount(transactions: any[]): number {
    let totalCreditAmount = 0;
    transactions.forEach(transaction => {
      totalCreditAmount += transaction.totalsubCreditAmount;
    });
    return totalCreditAmount;
  }

  fetchStatement() {
    this.apiService.getData().subscribe(
      (response) => {
        this.statement = response;
        if (this.isModal && this.dialogData?.ledger_id && this.statement?.length > 0) {
          if (this.statementType) return this.onSearch();

          this.apiService.getledgerById(this.dialogData.ledger_id).subscribe(
            (res: any) => {
              const maps = res?.ledger?.get_ledger_map || [];
              this.statementType = this.statement.find(s => maps.some(m => m.statement_id == s.id));
              this.onSearch();
            },
            () => {
              this.onSearch();
            }
          );
        }
      },
      (error) => console.log("Error fetching data:", error)
    );
  }

    getEmployeeData() {
    this.apiService.getAllEmployeeMasterList().subscribe(
      (response) => {
        console.log('Employee List response:', response);
        this.employee_data = response?.data || [];
      },
      (error) => {
        console.error('Error fetching employee list:', error);
      }
    );
  }

  fetchData(statementId: number, branchId?: any, profitCostId?: any, sectionId?: any, storeId?: any, fromDate?: string, toDate?: string, ledgerType?: any, value?: any): void {
    console.log("statementId", statementId);
    console.log("branchId", branchId);
    console.log("fromDate", fromDate);
    console.log("toDate", toDate);
    console.log("ledgerType", ledgerType);
    console.log("value", value);
    console.log("profitCostId", profitCostId);
    console.log("sectionId", sectionId);
    console.log("storeId", storeId);

    this.apiService.getstatementview(statementId, branchId, profitCostId, sectionId, storeId, fromDate, toDate, ledgerType, value).subscribe(
      (response: any) => {
        this.statementTransactions = response;
        if (this.isModal && this.dialogData?.ledger_id) {
          this.expandLedgerPath(this.dialogData.ledger_id);
        }
      },
      (error) => {
        console.log("Error fetching data:", error);
      }
    );
  }

  expandLedgerPath(ledgerId: any) {
    if (!this.statementTransactions) return;

    const hasLedger = (node: any) => node.groupLedgers?.some((l: any) => (l.ledger_id ?? l.id) == ledgerId);
    const expand = (node: any, isSubgroup = false) => {
      const found = hasLedger(node) || node.subgroups?.some((s: any) => expand(s, true));
      if (found && isSubgroup && !this.isSubgroupOpen(node)) this.openedGroups.push(node);
      return found;
    };

    this.statementTransactions.forEach(s => {
      let found = false;
      s.drTransactions?.forEach(g => { if (expand(g)) g.isOpenDr = found = true; });
      s.crTransactions?.forEach(g => { if (expand(g)) g.isOpenCr = found = true; });
      if (found) s.isOpenStatement = true;
    });

    setTimeout(() => {
      document.getElementById('ledger-' + ledgerId)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 0);
  }
  openImportModal() {
    const dialogRef = this.dialog.open(ImportStatementViewComponent, {
      width: '1200px',
      height: '550px'
    });

    dialogRef.afterClosed().subscribe((result: string) => {
      this.fetchStatement();
      if (result) {
        console.log('import statement:', result);
      }
    });
  }

  onSearch() {
    if (!this.statementType) {
      return;
    }
    
    // Validate date range
    if (this.fromDate && this.toDate && this.fromDate > this.toDate) {
      alert('From date cannot be greater than To date');
      return;
    }
    
    this.expandAll();
    if(this.branch){
      this.fetchData(this.statementType.id, this.branch.id,this.profitcost, this.section_id, this.store_id, this.fromDate, this.toDate,this.ledgerType,this.value);
    }else{
      this.fetchData(this.statementType.id, 0, this.profitcost, this.section_id, this.store_id, this.fromDate, this.toDate,this.ledgerType,this.value);
    }
    this.creditSide = this.statementType.top_heading;
    this.debitSide = this.statementType.bottom_heading;
    this.statement_name = this.statementType.name;
  }

  onSelectStatement() {
    // This method is kept for backward compatibility but search is now triggered by onSearch()
    this.onSearch();
  }

  getDebitStatementTransactions() {
    return this.statementTransactions;
  }

  toggleGroupStatement(statement: string) {
    const statementTransaction = this.statementTransactions.find(t => t.statement === statement);
    if (statementTransaction) {
      statementTransaction.isOpenStatement = !statementTransaction.isOpenStatement;
    }
  }

  isOpenStatement(statement: string) {
    const statementTransaction = this.statementTransactions.find(t => t.statement === statement);
    return statementTransaction ? statementTransaction.isOpenStatement : false;
  }

  toggleGroupDr(groupdr: string) {
    const transactionDr = this.statementTransactions.flatMap(st => st.drTransactions).find(t => t.groupdr === groupdr);
    if (transactionDr) {
      transactionDr.isOpenDr = !transactionDr.isOpenDr;
    }
  }

  isOpendr(groupdr: string) {
    const transactionDr = this.statementTransactions.flatMap(st => st.drTransactions).find(t => t.groupdr === groupdr);
    return transactionDr ? transactionDr.isOpenDr : false;
  }

  toggleGroupCr(groupcr: string) {
    const transactionCr = this.statementTransactions.flatMap(st => st.crTransactions).find(t => t.groupcr === groupcr);
    if (transactionCr) {
      transactionCr.isOpenCr = !transactionCr.isOpenCr;
    }
  }

  isOpencr(groupcr: string) {
    const transactionCr = this.statementTransactions.flatMap(st => st.crTransactions).find(t => t.groupcr === groupcr);
    return transactionCr ? transactionCr.isOpenCr : false;
  }

  toggleSubgroupDr(subgroup: any) {
    if (this.isSubgroupOpen(subgroup)) {
      this.openedGroups = this.openedGroups.filter(s => s !== subgroup);
    } else {
      this.openedGroups.push(subgroup);
    }
  }

  toggleSubgroupCr(subgroup: any) {
    if (this.isSubgroupOpen(subgroup)) {
      this.openedGroups = this.openedGroups.filter(s => s !== subgroup);
    } else {
      this.openedGroups.push(subgroup);
    }
  }

  isSubgroupOpen(subgroup: any) {
    return this.openedGroups.includes(subgroup);
  }
  toggleExpand() {
    if (this.isExpanded) {
      this.collapseAll();
    } else {
      this.expandAll();
    }
    this.isExpanded = !this.isExpanded;
  }

  expandAll() {
    this.statementTransactions.forEach(transaction => {
      transaction.isOpenStatement = true;
      if (transaction.drTransactions) {
        transaction.drTransactions.forEach(drTransaction => {
            drTransaction.isOpenDr = true;
            this.expandSubgroups(drTransaction.subgroups);
        });
    }
      if (transaction.crTransactions) {
        transaction.crTransactions.forEach(crTransaction => {
            crTransaction.isOpenCr = true;
            this.expandSubgroups(crTransaction.subgroups); 
        });
    }
    });
  }
  
  expandSubgroups(subgroups) {
    if (!subgroups) return;
    subgroups.forEach(subgroup => {
        this.toggleSubgroupDr(subgroup);
        this.expandSubgroups(subgroup.subgroups);
    });
  }
  
  collapseAll() {
    this.statementTransactions.forEach(transaction => {
      transaction.isOpenStatement = false;
  
      if (transaction.drTransactions) {
        transaction.drTransactions.forEach(drTransaction => {
          drTransaction.isOpenDr = false;
        });
      }
      if (transaction.crTransactions) {
        transaction.crTransactions.forEach(crTransaction => {
          crTransaction.isOpenCr = false;
        });
      }
    });
  }

  export(format: string) {
    if (format === 'excel') {
      this.exportToExcel();
    } else if (format === 'pdf') {
      this.convertToPdf();
    } else {
      console.error('Unsupported format. Please choose either "excel" or "pdf".');
    }
  }

  exportToExcel() {
    const dataToSend = this.statementTransactions;
    let CrCrAmount = 0;
    let CrDrAmount = 0;
    let DrCrAmount = 0;
    let DrDrAmount = 0;
    let totalcr = 0;
    let totaldr = 0;

    dataToSend.forEach(transaction => {
      if (transaction.crTransactions && transaction.crTransactions.length > 0) {
        transaction.crTransactions.forEach(crTransaction => {
          CrCrAmount += crTransaction.totalsubCreditAmount,
            CrDrAmount += crTransaction.totalsubDebitAmount;
        });
      }
      if (transaction.drTransactions && transaction.drTransactions.length > 0) {
        transaction.drTransactions.forEach(drTransaction => {
          DrCrAmount += drTransaction.totalsubCreditAmount;
          DrDrAmount += drTransaction.totalsubDebitAmount;
        });
      }
      totalcr = CrCrAmount + DrCrAmount;
      totaldr = CrDrAmount + DrDrAmount;
    });
    const exportdata = {
      exportType: 'excel',
      expanded: 'True',
      data: dataToSend,
      totalCrAmount: totalcr,
      totalDrAmount: totaldr,
      openGroup: this.openedGroups,
    }
    this.apiService.sendexportdata(exportdata).subscribe(response => {

      const downloadUrl = response[0];
      const blob = new Blob([response], { type: 'application/pdf' });

      const downloadLink = document.createElement('a');
      downloadLink.href = downloadUrl;
      downloadLink.download = 'statement.xlsx';
      downloadLink.target = '_blank';

      document.body.appendChild(downloadLink);
      downloadLink.click();

      document.body.removeChild(downloadLink);
    }, error => {
      console.error('Error sending data:', error);
    });
  }

  convertToPdf() {

    const dataToSend = this.statementTransactions;
    let CrCrAmount = 0;
    let CrDrAmount = 0;
    let DrCrAmount = 0;
    let DrDrAmount = 0;
    let totalcr = 0;
    let totaldr = 0;

    dataToSend.forEach(transaction => {
      if (transaction.crTransactions && transaction.crTransactions.length > 0) {
        transaction.crTransactions.forEach(crTransaction => {
          CrCrAmount += crTransaction.totalsubCreditAmount,
            CrDrAmount += crTransaction.totalsubDebitAmount;
        });
      }
      if (transaction.drTransactions && transaction.drTransactions.length > 0) {
        transaction.drTransactions.forEach(drTransaction => {
          DrCrAmount += drTransaction.totalsubCreditAmount;
          DrDrAmount += drTransaction.totalsubDebitAmount;
        });
      }
      totalcr = CrCrAmount + DrCrAmount;
      totaldr = CrDrAmount + DrDrAmount;
    });
    const exportdata = {
      exportType: 'pdf',
      expanded: 'True',
      data: dataToSend,
      totalCrAmount: totalcr,
      totalDrAmount: totaldr,
      openGroup: this.openedGroups,
    }
    this.apiService.sendexportdata(exportdata).subscribe(response => {

      const downloadUrl = response[0];
      const blob = new Blob([response], { type: 'application/pdf' });
      const downloadLink = document.createElement('a');
      downloadLink.href = downloadUrl;
      downloadLink.download = 'statement.pdf';
      downloadLink.target = '_blank';

      document.body.appendChild(downloadLink);
      downloadLink.click();

      document.body.removeChild(downloadLink);
    }, error => {
      console.error('Error sending data:', error);
    });
  }

  openLedgerBookModal(ledgerId?: any, ledgerName?: string) {
    this.dialog.open(LedgerBookComponent, {
      width: '95vw',
      height: '95vh',
      maxWidth: '100vw',
      data: {
        ledger_id: ledgerId,
        ledger_name: ledgerName,
        is_modal: true,
        from_date: this.fromDate,
        to_date: this.toDate,
        branch_id: this.branch ? this.branch.id : null
      },
      panelClass: 'custom-modal-box'
    });
  }

  calculateClosingBalanceSummary(transaction: any) {
    const crSideClosingBalance = this.calculateClosingBalanceAndSide(transaction.crTransactions);
    const drSideClosingBalance = this.calculateClosingBalanceAndSide(transaction.drTransactions);
    const closingBalanceSide = crSideClosingBalance.balance > drSideClosingBalance.balance ? crSideClosingBalance.side : drSideClosingBalance.side;
    const closingBalanceSummary = crSideClosingBalance.balance - drSideClosingBalance.balance;
    return { closingBalanceSummary: Math.abs(closingBalanceSummary), closingBalanceSide: closingBalanceSide };
  }
  calculateOpeningBalanceSummary(transaction: any) {
    let totalSummary = 0;
    const openingBalanceCr = this.calculateOpeningBalanceAndSide(transaction.crTransactions);
    const openingBalanceDr = this.calculateOpeningBalanceAndSide(transaction.drTransactions);
    const openingBalnceSide = openingBalanceCr.balance > openingBalanceDr.balance ? openingBalanceCr.side : openingBalanceDr.side;
    totalSummary = openingBalanceCr.balance - openingBalanceDr.balance;
    return { totalSummary: Math.abs(totalSummary), openingBalnceSide: openingBalnceSide };

  }
  calculateDebitAmountSummary(transaction: any) {
    const crSideDebitAmount = this.calculateDebitAmount(transaction.crTransactions);
    const drSideDebitAmount = this.calculateDebitAmount(transaction.drTransactions);
    const debitSummary = crSideDebitAmount - drSideDebitAmount;
    return { debitSummary: Math.abs(debitSummary) };
  }
  calculateCreditAmountSummary(transaction: any) {
    const crSideCreditAmount = this.calculateCreditAmount(transaction.crTransactions);
    const drSideCreditAmount = this.calculateCreditAmount(transaction.drTransactions);
    const creditSummary = crSideCreditAmount - drSideCreditAmount;
    return { creditSummary: Math.abs(creditSummary) };
  }
  fetchLedgerTypeData() {
    this.apiService.getLedgerType().subscribe(
      (response) => {
        this.ledgerTypeList = response;
        console.log('Ledger Type Index:', this.ledgerTypeList);
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }

  isAllLedgerTypeSelected() {
    return (this.ledgerType?.length || 0) === (this.ledgerTypeList?.length || 0) && (this.ledgerTypeList?.length || 0) > 0;
  }

  toggleAllLedgerType(checked: boolean) {
    if (checked) {
      this.ledgerType = (this.ledgerTypeList || []).map(item => item.id);
    } else {
      this.ledgerType = [];
    }
  }

  isAllValueSelected() {
    return (this.value?.length || 0) === (this.balance?.length || 0) && (this.balance?.length || 0) > 0;
  }

  toggleAllValue(checked: boolean) {
    if (checked) {
      this.value = (this.balance || []).map(item => item.id);
    } else {
      this.value = [];
    }
  }


  openLedgerVoucherModal(ledger: any, ledgerAmount: any): void {
    const dialogRef = this.dialog.open(VoucherBreakdownDialogComponent, {
      width: '95vw',
      maxWidth: '1400px',
      height: '90vh',
      data: {
        ledgerId: ledger.ledger_id || ledger.id,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Modal closed');
    });
  }
  isAllEmployeeSelected() {
    return (this.selectedEmployee?.length || 0) === (this.employee_data?.length || 0) && (this.employee_data?.length || 0) > 0;
  }

  toggleAllEmployee(checked: boolean) {
    if (checked) {
      this.selectedEmployee = (this.employee_data || []).map(item => item.id);
    } else {
      this.selectedEmployee = [];
    }
  }
}